import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddressSelector from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/useAddressSelector'
import PropTypes from 'prop-types'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import { SelectCopyOverlay, SelectWrapper } from '@/shared/theme/styled-components'

const AddressSelectorField = ({ module, validations, saleName, hidden }) => {
  if (hidden) return null
  const { t, label, addressesList, addressSelectorHandler, selectedValue, addressError, isEditable, getOptionLabel } =
    useAddressSelector(module, validations, saleName)

  if (!addressesList?.length) {
    return module === 'client' ? null : <p>{t('common:no_addresses_available')}</p>
  }

  const selectedLabel = selectedValue && addressesList ? addressesList[selectedValue] : null

  return (
    <FormControl error={addressError}>
      <SelectWrapper>
        <SDSelect
          label={label}
          disabled={!isEditable}
          optionsList={addressesList}
          onChangeHandler={params => addressSelectorHandler(params.option?.id)}
          selectedValue={selectedValue}
          placeholder={t('common:choose')}
          getOptionLabel={getOptionLabel}
        />
        <SelectCopyOverlay>
          <CopyEndEnhancer value={selectedLabel} />
        </SelectCopyOverlay>
      </SelectWrapper>
    </FormControl>
  )
}

AddressSelectorField.propTypes = {
  module: PropTypes.string,
  validations: PropTypes.object,
  saleName: PropTypes.string,
  hidden: PropTypes.bool,
}

export default AddressSelectorField
